
export class UtilService {

    formatCurrency(amount) {
        if (!amount) {
            return null;
        }
        let parts = String(amount.toFixed(2)).split('.');
        let cents = parts[1]
        let reverseDollar = parts[0].split('').reverse().map((num, index) => {
            let commaNum = 1;
            if ((index + 1) / (3 * commaNum) === 1) {
                commaNum++;
                return ',' + num;
            }
            return num;
        });
        return '$' + reverseDollar.reverse().join('') + '.' + cents;
    }

}